import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { ConsMgmnttWebApiWriteChannelApi } from './ConsentManagementConsMgmnttWebApiWriteChannelApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.WebApi.ConsentManagement.ConsMgmntWebApiWriteExtRequest
 * erweiterter Write Request für die WebApi für die Applikation Landing Pages
 * Endpoints: /api/consentmanagement/zustimmenapplikation
 */
export class ConsMgmntWebApiWriteExtRequestApi extends BaseApiModel {
	constructor(initialProperties?: Partial<ConsMgmntWebApiWriteExtRequestApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected betreff: string;
	/**
	 * Description: Betreff der Mail bei Aufruf über eine Landingpage
	 * APIL Type: string
	 */
	get Betreff(): string {
		return this.betreff;
	}

	/**
	 * Description: Betreff der Mail bei Aufruf über eine Landingpage
	 * APIL Type: string
	 */
	set Betreff(value: string) {
		this.betreff = value;
	}

	protected mailTitel: string;
	/**
	 * Description: Titel der Mail bei Aufruf über eine Landingpage
	 * APIL Type: string
	 */
	get MailTitel(): string {
		return this.mailTitel;
	}

	/**
	 * Description: Titel der Mail bei Aufruf über eine Landingpage
	 * APIL Type: string
	 */
	set MailTitel(value: string) {
		this.mailTitel = value;
	}

	protected mailTextEmail: string;
	/**
	 * Description: Text der Mail beim Telefon
	 * APIL Type: string
	 */
	get MailTextEmail(): string {
		return this.mailTextEmail;
	}

	/**
	 * Description: Text der Mail beim Telefon
	 * APIL Type: string
	 */
	set MailTextEmail(value: string) {
		this.mailTextEmail = value;
	}

	protected mailTextTelefon: string;
	/**
	 * Description: Text der Mail bei der Email
	 * APIL Type: string
	 */
	get MailTextTelefon(): string {
		return this.mailTextTelefon;
	}

	/**
	 * Description: Text der Mail bei der Email
	 * APIL Type: string
	 */
	set MailTextTelefon(value: string) {
		this.mailTextTelefon = value;
	}

	protected mitgliedsnummer: string;
	/**
	 * Description: Mitgliedsnummer
	 * APIL Type: string
	 */
	get Mitgliedsnummer(): string {
		return this.mitgliedsnummer;
	}

	/**
	 * Description: Mitgliedsnummer
	 * APIL Type: string
	 */
	set Mitgliedsnummer(value: string) {
		this.mitgliedsnummer = value;
	}

	protected vorname: string;
	/**
	 * Description: Vorname
	 * APIL Type: string
	 */
	get Vorname(): string {
		return this.vorname;
	}

	/**
	 * Description: Vorname
	 * APIL Type: string
	 */
	set Vorname(value: string) {
		this.vorname = value;
	}

	protected nachname: string;
	/**
	 * Description: Nachname
	 * APIL Type: string
	 */
	get Nachname(): string {
		return this.nachname;
	}

	/**
	 * Description: Nachname
	 * APIL Type: string
	 */
	set Nachname(value: string) {
		this.nachname = value;
	}

	protected strasseHausnummer: string;
	/**
	 * Description: Straße mit Hausnummer
	 * APIL Type: string
	 */
	get StrasseHausnummer(): string {
		return this.strasseHausnummer;
	}

	/**
	 * Description: Straße mit Hausnummer
	 * APIL Type: string
	 */
	set StrasseHausnummer(value: string) {
		this.strasseHausnummer = value;
	}

	protected postleitzahl: string;
	/**
	 * Description: Postleitzahl
	 * APIL Type: string
	 */
	get Postleitzahl(): string {
		return this.postleitzahl;
	}

	/**
	 * Description: Postleitzahl
	 * APIL Type: string
	 */
	set Postleitzahl(value: string) {
		this.postleitzahl = value;
	}

	protected ort: string;
	/**
	 * Description: Ort
	 * APIL Type: string
	 */
	get Ort(): string {
		return this.ort;
	}

	/**
	 * Description: Ort
	 * APIL Type: string
	 */
	set Ort(value: string) {
		this.ort = value;
	}

	protected processId: number;
	/**
	 * Description: Vorgangsnummer
	 * APIL Type: int64
	 */
	get ProcessId(): number {
		return this.processId;
	}

	/**
	 * Description: Vorgangsnummer
	 * APIL Type: int64
	 */
	set ProcessId(value: number) {
		this.processId = value;
	}

	protected werbesperre: boolean;
	/**
	 * Description: Werbesperre - alle Kanäle abgelehnt
	 * APIL Type: boolean
	 */
	get Werbesperre(): boolean {
		return this.werbesperre;
	}

	/**
	 * Description: Werbesperre - alle Kanäle abgelehnt
	 * APIL Type: boolean
	 */
	set Werbesperre(value: boolean) {
		this.werbesperre = value;
	}

	protected herkunftskennzeichen: string;
	/**
	 * Description: Herkunftskennzeichen des Consents
	 * APIL Type: string
	 */
	get Herkunftskennzeichen(): string {
		return this.herkunftskennzeichen;
	}

	/**
	 * Description: Herkunftskennzeichen des Consents
	 * APIL Type: string
	 */
	set Herkunftskennzeichen(value: string) {
		this.herkunftskennzeichen = value;
	}

	protected version: string;
	/**
	 * Description: Version, für die das Einverständnis für Werbung auf den verschiedenen Kanälen eingeholt wird, z. B "06"
	 * APIL Type: string
	 */
	get Version(): string {
		return this.version;
	}

	/**
	 * Description: Version, für die das Einverständnis für Werbung auf den verschiedenen Kanälen eingeholt wird, z. B "06"
	 * APIL Type: string
	 */
	set Version(value: string) {
		this.version = value;
	}

	protected trackingVersion: string;
	/**
	 * Description: Version, für die das Einverständnis zum Tracking eingeholt wird, z. B. 01
	 * APIL Type: string
	 */
	get TrackingVersion(): string {
		return this.trackingVersion;
	}

	/**
	 * Description: Version, für die das Einverständnis zum Tracking eingeholt wird, z. B. 01
	 * APIL Type: string
	 */
	set TrackingVersion(value: string) {
		this.trackingVersion = value;
	}

	protected trackingReferenzId: string;
	/**
	 * Description: ReferenzId, die für den API-Zugriff auf das Thema Tracking in BSI-CRM konfiguriert ist.
	 * APIL Type: string
	 */
	get TrackingReferenzId(): string {
		return this.trackingReferenzId;
	}

	/**
	 * Description: ReferenzId, die für den API-Zugriff auf das Thema Tracking in BSI-CRM konfiguriert ist.
	 * APIL Type: string
	 */
	set TrackingReferenzId(value: string) {
		this.trackingReferenzId = value;
	}

	protected gesellschaftsId: string;
	/**
	 * Description: Kennung der Gesellschaft des ADAC, die das Einverständnis eingeholt wird, z. B. 0020
	 * APIL Type: string
	 */
	get GesellschaftsId(): string {
		return this.gesellschaftsId;
	}

	/**
	 * Description: Kennung der Gesellschaft des ADAC, die das Einverständnis eingeholt wird, z. B. 0020
	 * APIL Type: string
	 */
	set GesellschaftsId(value: string) {
		this.gesellschaftsId = value;
	}

	protected gesellschaftsname: string;
	/**
	 * Description: Name der Gesellschaft des ADAC, die das Einverständnis eingeholt wird, z. B. 0020
	 * APIL Type: string
	 */
	get Gesellschaftsname(): string {
		return this.gesellschaftsname;
	}

	/**
	 * Description: Name der Gesellschaft des ADAC, die das Einverständnis eingeholt wird, z. B. 0020
	 * APIL Type: string
	 */
	set Gesellschaftsname(value: string) {
		this.gesellschaftsname = value;
	}

	protected ipAddress: string;
	/**
	 * Description: IP Adresse
	 * APIL Type: string
	 */
	get IpAddress(): string {
		return this.ipAddress;
	}

	/**
	 * Description: IP Adresse
	 * APIL Type: string
	 */
	set IpAddress(value: string) {
		this.ipAddress = value;
	}

	protected channelEmail: ConsMgmnttWebApiWriteChannelApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.WebApi.ConsentManagement.ConsMgmnttWebApiWriteChannel
	 */
	get ChannelEmail(): ConsMgmnttWebApiWriteChannelApi {
		return this.channelEmail;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.WebApi.ConsentManagement.ConsMgmnttWebApiWriteChannel
	 */
	set ChannelEmail(value: ConsMgmnttWebApiWriteChannelApi) {
		this.channelEmail = value;
	}

	protected channelTel1: ConsMgmnttWebApiWriteChannelApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.WebApi.ConsentManagement.ConsMgmnttWebApiWriteChannel
	 */
	get ChannelTel1(): ConsMgmnttWebApiWriteChannelApi {
		return this.channelTel1;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.WebApi.ConsentManagement.ConsMgmnttWebApiWriteChannel
	 */
	set ChannelTel1(value: ConsMgmnttWebApiWriteChannelApi) {
		this.channelTel1 = value;
	}

	protected channelTel2: ConsMgmnttWebApiWriteChannelApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.WebApi.ConsentManagement.ConsMgmnttWebApiWriteChannel
	 */
	get ChannelTel2(): ConsMgmnttWebApiWriteChannelApi {
		return this.channelTel2;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.WebApi.ConsentManagement.ConsMgmnttWebApiWriteChannel
	 */
	set ChannelTel2(value: ConsMgmnttWebApiWriteChannelApi) {
		this.channelTel2 = value;
	}

	protected trackingAuthorized: boolean;
	/**
	 * Description: Einwilligung für Tracking
	 * APIL Type: boolean
	 */
	get TrackingAuthorized(): boolean {
		return this.trackingAuthorized;
	}

	/**
	 * Description: Einwilligung für Tracking
	 * APIL Type: boolean
	 */
	set TrackingAuthorized(value: boolean) {
		this.trackingAuthorized = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): ConsMgmntWebApiWriteExtRequestApi {
		return AppUtils.Helper.createFromMap(dataObject, ConsMgmntWebApiWriteExtRequestApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'channelemail':
					return ConsMgmnttWebApiWriteChannelApi.createFromObject(value);
				case 'channeltel1':
					return ConsMgmnttWebApiWriteChannelApi.createFromObject(value);
				case 'channeltel2':
					return ConsMgmnttWebApiWriteChannelApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Betreff = this.betreff;
		result.MailTitel = this.mailTitel;
		result.MailTextEmail = this.mailTextEmail;
		result.MailTextTelefon = this.mailTextTelefon;
		result.Mitgliedsnummer = this.mitgliedsnummer;
		result.Vorname = this.vorname;
		result.Nachname = this.nachname;
		result.StrasseHausnummer = this.strasseHausnummer;
		result.Postleitzahl = this.postleitzahl;
		result.Ort = this.ort;
		result.ProcessId = this.processId;
		result.Werbesperre = this.werbesperre;
		result.Herkunftskennzeichen = this.herkunftskennzeichen;
		result.Version = this.version;
		result.TrackingVersion = this.trackingVersion;
		result.TrackingReferenzId = this.trackingReferenzId;
		result.GesellschaftsId = this.gesellschaftsId;
		result.Gesellschaftsname = this.gesellschaftsname;
		result.IpAddress = this.ipAddress;
		if (this.channelEmail) {
			result.ChannelEmail = this.channelEmail.toRequestObject();
		}
		if (this.channelTel1) {
			result.ChannelTel1 = this.channelTel1.toRequestObject();
		}
		if (this.channelTel2) {
			result.ChannelTel2 = this.channelTel2.toRequestObject();
		}
		result.TrackingAuthorized = this.trackingAuthorized;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}